/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { modifyWorkHistory } from '../../../apis/work-history';
import Form from '../../../components/Form';
import Modal, { ModalHeader } from '../../../components/Modal';
import { DAY_TYPES } from '../../../constants/WORK';
import useForm from '../../../hooks/useForm';
import { dateToFormat, dateToViewFormat, diffSeconds, formatHourSecond, hourSecondToseconds, secondsToHourSecond } from '../../../utils/date';
import systemAlert from '../../../utils/systemAlert';
import { toast } from '../../../utils/toast';

const WorkHistoryManager = ({ open, setOpen, historyData, setHistoryData, submit }) => {
  const { employees } = useSelector(
    (store) => ({
      employees: store.Data.employees,
    }),
  );
  const [fields] = useState([
    [
      {
        title: "근무시작일시",
        key: "workStartDate",
        type: "datepicker",
        required: true,
      },
      {
        key: "workStartTime",
        type: "timepicker",
        required: true,
      },
    ],
    [
      {
        title: "근무종료일시",
        key: "workEndDate",
        type: "datepicker",
        required: true,
      },
      {
        key: "workEndTime",
        type: "timepicker",
        required: true,
      },
    ],
    [
      {
        title: "출근일시",
        key: "commuteStartDate",
        type: "datepicker",
        required: true,
      },
      {
        key: "commuteStartTime",
        type: "timepicker",
        required: true,
      },
    ],
    [
      {
        title: "퇴근일시",
        key: "commuteEndDate",
        type: "datepicker",
        required: true,
      },
      {
        key: "commuteEndTime",
        type: "timepicker",
        required: true,
      },
    ],
    {
      title: '근무 유형',
      key: 'dayType',
      type: 'radio',
      options: {
        list: DAY_TYPES
      },
      required: true
    },
    {
      type: 'line'
    },
    {
      title: '근무시간',
      type: 'title'
    },
    [
      {
        title: '인정근무시간',
        key: 'admitWorkTimes',
        type: 'timepicker',
        required: true,
      },
      {
        title: '총근로시간',
        key: 'totalWorkTimes',
        type: 'timepicker',
        required: true,
      }
    ],
    [
      {
        title: '휴게시간',
        key: 'restTimes',
        type: 'timepicker',
        required: true
      },
      {
        title: '연장근무시간',
        key: 'extendWorkTimes',
        type: 'timepicker',
        required: true
      },
    ],
    [
      {
        title: '야간근무시간',
        key: 'nightWorkTimes',
        type: 'timepicker',
        required: true
      },
      {
        title: '기타근무시간',
        key: 'otherWorkTimes',
        type: 'timepicker',
        required: true
      },
    ],
  ]);

  const defaultForm = {
    workStartDate: '',
    workStartTime: '',
    workEndDate: '',
    workEndTime: '',
    commuteStartDate: '',
    commuteStartTime: '',
    commuteEndDate: '',
    commuteEndTime: '',
    dayType: '',
    restTimeInSeconds: 0,
    admitWorkTimeInSeconds: 0,
    totalWorkTimeInSeconds: 0,
    extendWorkTimeInSeconds: 0,
    nightWorkTimeInSeconds: 0,
    otherWorkTimeInSeconds: 0,
    admitWorkTimes: '',
    totalWorkTimes: '',
    restTimes: '',
    extendWorkTimes: '',
    nightWorkTimes: '',
    otherWorkTimes: '',
    isLate: false,
    isEarlyLeft: false,
  };

  const _submit = (form) => {
    const body = {
      historyIdxs: [historyData[0].idx],
      commuteStartTime: `${form.commuteStartDate[0]} ${form.commuteStartTime}`,
      commuteEndTime: `${form.commuteEndDate[0]} ${form.commuteEndTime}`,
      workStartTime: `${form.workStartDate[0]} ${form.workStartTime}`,
      workEndTime: `${form.workEndDate[0]} ${form.workEndTime}`,
      dayType: form.dayType,
      restTimeInSeconds: form.restTimeInSeconds,
      admitWorkTimeInSeconds: form.admitWorkTimeInSeconds,
      totalWorkTimeInSeconds: form.totalWorkTimeInSeconds,
      extendWorkTimeInSeconds: form.extendWorkTimeInSeconds,
      nightWorkTimeInSeconds: form.nightWorkTimeInSeconds,
      otherWorkTimeInSeconds: form.otherWorkTimeInSeconds,
      isLate: form.isLate,
      isEarlyLeft: form.isEarlyLeft,
    };

    if (isEmpty(form.workStartDate[0]) || isEmpty(form.workStartTime)) {
      return toast.error('근무시작일시 필수입니다. 근무일정 완료후 수정가능합니다.');
    }
    if (isEmpty(form.workEndDate[0]) || isEmpty(form.workEndTime)) {
      return toast.error('근무종료일시 필수입니다. 근무일정 완료후 수정가능합니다.');
    }
    if (isEmpty(form.commuteStartDate[0]) || isEmpty(form.commuteStartTime)) {
      return toast.error('출근일시 필수입니다');
    }
    if (isEmpty(form.commuteEndDate[0]) || isEmpty(form.commuteEndTime)) {
      return toast.error('퇴근일시 필수입니다');
    }

    if (diffSeconds(body.workStartTime, body.workEndTime) <= 0) return toast.error('근무종료일시는 근무시작일시 이후로 설정해주세요.');
    if (diffSeconds(body.commuteStartTime, body.commuteEndTime) <= 0) return toast.error('퇴근일시는 출근일시 이후로 설정해주세요.');

    // const today = new Date().getDate();
    if ((body.restTimeInSeconds > 0) && (body.admitWorkTimeInSeconds < body.restTimeInSeconds)) {
      return toast.error('휴게시간은 인정근무시간보다 클수 없습니다.');
    }

    systemAlert('해당 사용자의 출퇴근 기록을 수정하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '수정',
          onClick: () => {
            modifyWorkHistory(body).then(() => {
              submit();
              cancel();
            });
          }
        }
      ]
    });
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    // 인정시간, 총근무시간, 지각, 조퇴 계산
    const workStart = `${form.workStartDate[0]} ${form.workStartTime}`;
    const workEnd = `${form.workEndDate[0]} ${form.workEndTime}`;
    const commuteStart = `${form.commuteStartDate[0]} ${form.commuteStartTime}`;
    const commuteEnd = `${form.commuteEndDate[0]} ${form.commuteEndTime}`;

    // 출퇴근 시간이 근무 일정 범위내에 있을 경우 (지각 & 조퇴)
    if (diffSeconds(workStart, commuteStart) > 0 && diffSeconds(workEnd, commuteEnd) < 0) {
      setForm({
        ...form,
        admitWorkTimes: secondsToHourSecond(diffSeconds(commuteStart, commuteEnd) - form.restTimeInSeconds),
        totalWorkTimes: secondsToHourSecond(diffSeconds(commuteStart, commuteEnd) - form.restTimeInSeconds),
        isLate: true,
        isEarlyLeft: true
      });
    }
    // 출퇴근 시간이 근무 일정보다 같거나 클 경우 (정상 근무)
    if (diffSeconds(workStart, commuteStart) <= 0 && diffSeconds(workEnd, commuteEnd) >= 0) {
      setForm({
        ...form,
        admitWorkTimes: secondsToHourSecond(diffSeconds(workStart, workEnd) - form.restTimeInSeconds),
        totalWorkTimes: secondsToHourSecond(diffSeconds(commuteStart, commuteEnd) - form.restTimeInSeconds),
        isLate: false,
        isEarlyLeft: false
      });
    }
    // 출근 시간이 근무 일정 범위내에 있고 퇴근시간이 근무일정보다 클 경우 (지각)
    if (diffSeconds(workStart, commuteStart) > 0 && diffSeconds(workEnd, commuteEnd) >= 0) {
      setForm({
        ...form,
        admitWorkTimes: secondsToHourSecond(diffSeconds(commuteStart, workEnd) - form.restTimeInSeconds),
        totalWorkTimes: secondsToHourSecond(diffSeconds(commuteStart, commuteEnd) - form.restTimeInSeconds),
        isLate: true,
        isEarlyLeft: false
      });
    }
    // 퇴근 시간이 근무 일정 범위내에 있고 출근시간이 근무일정보다 클 경우 (조기퇴근)
    if (diffSeconds(workStart, commuteStart) <= 0 && diffSeconds(workEnd, commuteEnd) < 0) {
      setForm({
        ...form,
        admitWorkTimes: secondsToHourSecond(diffSeconds(workStart, commuteEnd) - form.restTimeInSeconds),
        totalWorkTimes: secondsToHourSecond(diffSeconds(commuteStart, commuteEnd) - form.restTimeInSeconds),
        isLate: false,
        isEarlyLeft: true
      });
    }
  }, [
    form.workStartDate,
    form.workStartTime,
    form.workEndDate,
    form.workEndTime,
    form.commuteStartDate,
    form.commuteStartTime,
    form.commuteEndDate,
    form.commuteEndTime,
    form.restTimeInSeconds
  ]);

  useEffect(() => {
    setForm({
      ...form,
      admitWorkTimeInSeconds: hourSecondToseconds(form.admitWorkTimes),
      totalWorkTimeInSeconds: hourSecondToseconds(form.totalWorkTimes),
      restTimeInSeconds: hourSecondToseconds(form.restTimes),
      extendWorkTimeInSeconds: hourSecondToseconds(form.extendWorkTimes),
      nightWorkTimeInSeconds: hourSecondToseconds(form.nightWorkTimes),
      otherWorkTimeInSeconds: hourSecondToseconds(form.otherWorkTimes),
    });
  }, [
    form.admitWorkTimes,
    form.totalWorkTimes,
    form.restTimes,
    form.extendWorkTimes,
    form.nightWorkTimes,
    form.otherWorkTimes,
  ]);

  useEffect(() => {
    // setValidateFields(fields)
    if (!isEmpty(historyData)) {
      const _form = {
        workStartDate: dateToFormat(historyData[0].workStartTime),
        workEndDate: dateToFormat(historyData[0].workEndTime),
        workStartTime: dateToFormat(historyData[0].workStartTime, formatHourSecond),
        workEndTime: dateToFormat(historyData[0].workEndTime, formatHourSecond),
        commuteStartDate: dateToFormat(historyData[0].commuteStartTime) || dateToFormat(historyData[0].workStartTime),
        commuteEndDate: dateToFormat(historyData[0].commuteEndTime) || dateToFormat(historyData[0].workEndTime),
        commuteStartTime: dateToFormat(historyData[0].commuteStartTime, formatHourSecond) || '09:00:00',
        commuteEndTime: dateToFormat(historyData[0].commuteEndTime, formatHourSecond) || '18:00:00',
        dayType: historyData[0].dayType,
        restTimeInSeconds: historyData[0].restTimeInSeconds,
        admitWorkTimeInSeconds: historyData[0].admitWorkTimeInSeconds,
        totalWorkTimeInSeconds: historyData[0].totalWorkTimeInSeconds,
        extendWorkTimeInSeconds: historyData[0].extendWorkTimeInSeconds,
        nightWorkTimeInSeconds: historyData[0].nightWorkTimeInSeconds,
        otherWorkTimeInSeconds: historyData[0].otherWorkTimeInSeconds,
        isLate: historyData[0].isLate,
        isEarlyLeft: historyData[0].isEarlyLeft,
        admitWorkTimes: historyData[0].admitWorkTimes,
        totalWorkTimes: historyData[0].totalWorkTimes,
        restTimes: historyData[0].restTimes,
        extendWorkTimes: historyData[0].extendWorkTimes,
        nightWorkTimes: historyData[0].nightWorkTimes,
        otherWorkTimes: historyData[0].otherWorkTimes,
      };
      setForm(_form);
      setOriginForm(_form);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, historyData, fields]);

  const cancel = () => {
    setOpen(false);
    setHistoryData([]);
  };

  const getTitle = () => {
    const data = historyData[0];
    const employeeName = employees.find((employee) => employee.idx === data.employeeIdx).name;

    return (
      `${employeeName}님 (${dateToViewFormat(data.workDate)}) 근무 기록 수정`
    );
  };

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="commute-time-manager">
        <ModalHeader>{getTitle()}</ModalHeader>
        <Form
          isRequiredShow={true}
          fields={fields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  );
};

export default WorkHistoryManager;